import { inject, Injectable } from '@angular/core';
import { spri_CONFIG } from '@spri/services/config/config.constants';
import { merge } from 'lodash-es';
import type { Observable } from 'rxjs';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SpriConfigService<T = unknown> {
  private configSubject = new BehaviorSubject<T>(inject(spri_CONFIG) as T);

  /**
   * Setter & getter for config
   */

  public set config(value: T) {
    // Merge the new config over to the current config
    const config = merge({}, this.configSubject.getValue(), value);
    // Execute the observable
    this.configSubject.next(config);
  }

  public readonly config$: Observable<T> = this.configSubject.asObservable();

  /**
   * Resets the config to the default
   */
  public reset(): void {
    // Set the config
    this.configSubject.next(this.config);
  }
}
